import { dataHooks } from '@wix/data-hooks';

export const userContactsDataHooks = dataHooks<{
  avatar;
  name;
  phoneNumber;
  email;
  emailCopyIconTooltip;
  localTime;
  bookASessionLink;
}>('userContacts');
